'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueBlock = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VenueBlock = exports.VenueBlock = function VenueBlock(_ref) {
  var imageUrl = _ref.imageUrl,
      url = _ref.url,
      venue = _ref.venue;
  return _react2.default.createElement(
    _reactRouter.Link,
    { className: 'venue-block', to: url },
    _react2.default.createElement(
      'span',
      { className: 'venue-block__text' },
      venue
    ),
    imageUrl && _react2.default.createElement('div', { className: 'venue-block__image', style: { backgroundImage: 'url(' + imageUrl + ')' } })
  );
};

VenueBlock.propTypes = {
  imageUrl: _propTypes2.default.string,
  url: _propTypes2.default.string,
  venue: _propTypes2.default.string
};